import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './Card.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TooltipInformation from '../TooltipInformation/TooltipInformation';
import viewport from '../../common/viewport';
import logComponent from '../../common/logComponent';

export default function Card({ title, icon, children, className, moduleDescription }) {
  const [tooltipInformationVisible, setTooltipInformationVisible] = useState(false);
  const [viewportIsMdBelow, setViewportIsMdBelow] = useState(viewport.isMdBelow());
  const infoItemRef = useRef(null);
  
  const [content, setContent] = useState('');
  const [link, setLink] = useState('');

  useEffect(() => {
    if (logComponent('Card')) {console.debug('Card mount'); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (children instanceof Array) {
      setContent(children[0]);
      setLink(children[1]);
    } else if (typeof children === 'object') {
      setContent(children);
      setLink('');
    }
    window.addEventListener('resize', checkViewport);
    return function cleanup() {
      window.removeEventListener('resize', checkViewport);
    };
  }, []);





  const focusInfoItem = () => {
    if (logComponent('Card')) {console.debug('Card focusInfoItem'); }
    if (infoItemRef.current) {
      infoItemRef.current.focus();    }
  }

  const checkViewport = () => {
    if (logComponent('Card')) {console.debug('Card checkViewport'); }
    if (viewport.isMdBelow() !== viewportIsMdBelow) {
      setViewportIsMdBelow(viewport.isMdBelow());
    }
  }

  const handleButtonClick = () => {
    if (logComponent('Card')) {console.debug('Card handleButtonClick'); }
    if (viewport.isMdBelow()) {
      focusInfoItem();
    }
    setTooltipInformationVisible(!tooltipInformationVisible);
    
  }

  const handleButtonBlur = () => {
    if (logComponent('Card')) {console.debug('Card handleButtonBlur'); }
    setTimeout(() => {
      setTooltipInformationVisible(false);
    }, 200);
  }

    
  return (
    <div className={ 'Card' + (className ? ' ' + className : '') } >
        
      {/* CARD HEADER */}
      <div className="Card__header">
        <FontAwesomeIcon icon={icon} className="Card__icon" />  
        <h2 className="Card__title">{title}</h2>
{ moduleDescription && 
          <div className="Card__tooltip-wrapper">
          { viewportIsMdBelow && 

            <button
              className="Card__info-btn"
              onClick={handleButtonClick}
              onBlur={handleButtonBlur}
              ref={infoItemRef}>
              <FontAwesomeIcon icon="info-circle" className="Card__info" />
            </button>
          }
          { !viewportIsMdBelow && 
            <button
              className="Card__info-btn"
              onMouseEnter={handleButtonClick}
              onMouseLeave={handleButtonBlur}>
              <FontAwesomeIcon icon="info-circle" className="Card__info" />
            </button>

          }


          <TooltipInformation
            isVisible={tooltipInformationVisible}
            description={moduleDescription}  />          
        </div>
}
      </div>

      {/* CARD CONTENT */}
      { content }        
      

      {/* CARD FOOTER */}
      { link && 
        <div className="Card__footer-link">{ link }</div> 
      }
    </div>      

  );
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  className: PropTypes.string
}

